export var FlashMessageEnum;
(function (FlashMessageEnum) {
    FlashMessageEnum["alert"] = "alert";
    FlashMessageEnum["success"] = "success";
    FlashMessageEnum["info"] = "info";
    FlashMessageEnum["warning"] = "warning";
})(FlashMessageEnum || (FlashMessageEnum = {}));
